import { FlexRow } from '@components/FlexRow';
import { Box, Button, IconButton, lighten, Select, styled } from '@mui/material';

// Export reusable filter chip components
export { FilterChip, filterChipSx, FilterChipDeleteIcon } from './FilterChip';
export type { FilterChipProps } from './FilterChip';
export { FilterChips } from './FilterChips';
export type { FilterChipsProps, ChipLabelItem } from './FilterChips';

// Styled components
export const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

export const SortContainer = styled(FlexRow)(({ theme }) => ({
    gap: '0.25rem',
}));

export const FilterButtonStyled = styled(IconButton)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.background.paper,
    border: `2px solid ${theme.palette.border.main}`,
    borderRadius: '12px',
    width: '50px',
    height: '48px',
}));

interface ButtonViewProps {
    theme?: any;
    activeView?: boolean;
}

export const ButtonView = styled(Button)<ButtonViewProps>(({ theme, activeView }) => ({
    minWidth: '53px !important',
    width: '53px !important',
    maxWidth: '53px',
    maxHeight: '45px',
    borderColor: activeView ? theme.palette.primary.main : theme.palette.secondary.main,
    background: activeView ? theme.palette.primary.main : 'none',
    borderRadius: '0',
    // if disabled set color to be more lighter
    "&.Mui-disabled": {
        "& i": {
            color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : lighten(theme.palette.neutralGray.main, 0.5),
        },
    },
    "& i": {
        fontSize: '20px',
        color: activeView ? theme.palette.common.white : theme.palette.neutralGray.main,
        paddingTop: '3px',
    },
    "&:hover": {
        background: activeView ? theme.palette.primary.main : theme.palette.primary.light,
        "& i": {
            color: theme.palette.common.white
        },
    },
}));

export const FilterSelectMenu = styled(Select)(({ theme }) => ({
    minWidth: '134px',
    borderRadius: '12px',
    fontWeight: 600,
    '& .MuiSelect-select': {
        padding: '11px 14px'
    },
    background: theme.palette.background.paper,
    border: `2px solid ${theme.palette.border.main}`,
}));

export const FilterHeading = styled(FlexRow)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.darkGrey.main}`,
    marginBottom: '1rem',
    padding: '4px 0',
}));

export const DrawerContainer = styled('div')(({ theme }) => ({
    width: '380px',
    padding: '1rem 1.5rem',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    background: 'inherit',
    '& .MuiAutocomplete-root': {
        maxWidth: '100% ',
    },
    minHeight: '100%',
}));

export const NewFilterButton = styled(IconButton)(({ theme }) => ({
    width: '48px',
    height: '44px',
    border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.border.main}`,
    borderRadius: '12px',
    padding: '12px 16px',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.mode === 'dark' ? theme.palette.grey[400] : theme.palette.neutralGray.main,
}));

export const ButtonViewContainer = styled(Box)(({ theme }) => ({
    border: `2px solid ${theme.palette.border.main}`,
    borderRadius: '12px',
    display: 'flex',
    height: '46px',
    background: theme.palette.background.paper,
    "& button:first-child": {
        borderRadius: '10px 0 0 10px',
    },
    "& button:last-child": {
        borderRadius: '0 10px 10px 0',
    },
}));
